import {
  AppSessionJwts,
  SessionTokenData,
  ValidationTokenData,
} from '@mangovoice/types'

export interface AuthenticationState {
  validationToken?: ValidationTokenData
  appSessionJwts?: AppSessionJwts
  session?: SessionTokenData
}

export enum AuthenticationUpdateType {
  ValidationToken = 'validationToken',
  AppSessionJwt = 'appSessionJwt',
  Session = 'session',
}
